const defaultState = {
    type:"",
    payload:{}
}

const workspaceReducer = (state = defaultState,action) =>{
    switch(action.type){
       case "SET_WORKSPACE":
           return {
               type:"SET_WORKSPACE",
               payload:action.payload,
           }
        case "UN_SET_WORKSPACE":
            return {
                type:"UN_SET_WORKSPACE",
                payload:{},
            }
        default:
            return state;
    }
}

export default workspaceReducer;
